module.exports = require("babel-runtime/helpers/asyncToGenerator");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/asyncToGenerator"
// module id = 14
// module chunks = 0